import * as ng from 'angular';

export class StTableController implements ng.IController {
    static $inject: string[] = [
        '$scope',
        '$parse',
        '$filter',
        '$attrs'
    ];
    private tableState: any = {
        sort: {},
        search: {},
        pagination: {
            start: 0
        }
    };

    private propertyName: any;
    private displayGetter: any;
    private displaySetter: any;
    private safeGetter: any;
    private orderBy: any;
    private filter: any;
    private safeCopy: any;
    private pipeAfterSafeCopy: boolean = true;
    private preventPipe: Function;
    private getTableState: Function;

    constructor(
        private $scope: any,
        private $parse: ng.IParseService,
        private $filter: ng.IFilterService,
        private $attrs: any
    ) {

        this.propertyName = $attrs.stTable;
        this.displayGetter = $parse(this.propertyName);
        this.displaySetter = this.displayGetter.assign;
        this.orderBy = $filter('orderBy');
        this.filter = $filter('filter');
        this.safeCopy = this.copyRefs(this.displayGetter($scope));

        if ($attrs.stSafeSrc) {
            this.safeGetter = $parse($attrs.stSafeSrc);
            $scope.$watch(() => {
                let safeSrc = this.safeGetter($scope);
                return safeSrc ? safeSrc.length : 0;

            }, (newValue, oldValue) => {
                if (newValue !== oldValue) {
                    this.updateSafeCopy();
                }
            });
            $scope.$watch(() => {
                return this.safeGetter($scope);
            }, (newValue, oldValue) => {
                if (newValue !== oldValue) {
                    this.updateSafeCopy();
                }
            });
        }

        /**
         * Usually when the safe copy is updated the pipe function is called.
         * Calling this method will prevent it, which is something required when using a custom pipe function
         */
        this.preventPipe = () => {
            this.pipeAfterSafeCopy = false;
        };

        /**
         * return the current state of the table
         * @returns {{sort: {}, search: {}, pagination: {start: number}}}
         */
        this.getTableState = () => {
            return this.tableState;
        };
    }

    private copyRefs(src: any) {
        return [].concat(src);
    }

    private updateSafeCopy() {
        this.safeCopy = this.copyRefs(this.safeGetter(this.$scope));
        if (this.pipeAfterSafeCopy === true) {
            this.pipe();
        }
    }

    /**
     * sort the rows
     * @param predicate function or string which will be used as predicate for the sorting
     * @param [optional] reverse if you want to reverse the order
     */

    private sortBy(predicate: any, reverse: any) {
        this.tableState.sort.predicate = predicate;
        this.tableState.sort.reverse = reverse === true;
        this.tableState.pagination.start = 0;
        this.pipe();
    }

    /**
     * search matching rows
     * @param input the input string
     * @param predicate [optional] the property name against you want to check the match, otherwise it will search on all properties
     */
    private search(input: any, predicate: any) {
        var predicateObject = this.tableState.search.predicateObject || {};
        var prop = predicate ? predicate : '$';
        predicateObject[prop] = input;
        this.tableState.search.predicateObject = predicateObject;
        this.tableState.pagination.start = 0;
        this.pipe();
    }

    /**
     * this will chain the operations of sorting and filtering based on the current table state (sort options, filtering, ect)
     */
    private pipe() {
        let filtered = this.tableState.search.predicateObject ? this.filter(this.safeCopy, this.tableState.search.predicateObject) : this.safeCopy;
        filtered = this.orderBy(filtered, this.tableState.sort.predicate, this.tableState.sort.reverse);
        if (this.tableState.pagination.number !== undefined) {
            this.tableState.pagination.numberOfPages = filtered.length > 0 ? Math.ceil(filtered.length / this.tableState.pagination.number) : 1;
            filtered = filtered.slice(this.tableState.pagination.start, this.tableState.pagination.start + this.tableState.pagination.number);
        }
        this.displaySetter(this.$scope, filtered);
    }

    /**
     * select a dataRow (it will add the attribute isSelected to the row object)
     * @param row the row to select
     * @param mode "single" or "multiple"
     */
    private select(row: any, mode: any) {
        let rows = this.displayGetter(this.$scope);
        let index = rows.indexOf(row);
        if (index !== -1) {
            if (mode === 'single') {
                ng.forEach(this.displayGetter(this.$scope), (value, key) => {
                    value.isSelected = key === index ? !value.isSelected : false;
                });
            } else {
                rows[index].isSelected = !rows[index].isSelected;
            }
        }
    }

    /**
     * take a slice of the current sorted/filtered collection (pagination)
     *
     * @param start index of the slice
     * @param number the number of item in the slice
     */
    private splice(start: any, number: any) {
        this.tableState.pagination.start = start;
        this.tableState.pagination.number = number;
        this.pipe();
    }

    /**
     * Use a different filter function than the angular FilterFilter
     * @param filterName the name under which the custom filter is registered
     */
    private setFilterFunction(filterName: any) {
        this.filter = this.$filter(filterName);
    }

    /**
     * user a different function than the angular orderBy
     * @param sortFunctionName the name under which the custom order function is registered
     */
    private setSortFunction(sortFunctionName: any) {
        this.orderBy = this.$filter(sortFunctionName);
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/third/smart-table/st-table/st-table.ts